import { SxProps, SystemStyleObject } from "@mui/system";
import { ThemeV2 } from "../../util/types";

export const wrapperStyle = {
  display: "flex",
  justifyContent: "center",
  width: "100%",
  gap: 2,
};

export const hintsBox: SxProps = {
  wordBreak: "normal",
  // flex: 1,
  backgroundColor: "green",
};

export const buttonCompWrapper = (dynamicHeight: number): SxProps => ({
  marginBottom: 2,
  display: "flex",
  flexDirection: "row",
  gap: 1,
  minHeight: "40px",
  maxHeight: dynamicHeight,
  height: "100%",
});

/* c8 ignore start */
export const leftRightButtonWrapper = (sideShowShadow: boolean): SxProps => {
  return {
    width: "70vh",
    display: "flex",
    flexDirection: "column",
    minWidth: { md: "70%", xs: "40%" },
    ...(sideShowShadow && {
      overflowX: "scroll",
      boxShadow:
        "rgba(0, 0, 0, 0.25) -30px 0px 20px -30px inset, rgba(0, 0, 0, 0.25) 30px 0px 20px -30px inset",
    }),
  };
};
/* c8 ignore end */

export const portraitButtonOptionsRow = (optionCount: number): SxProps => ({
  display: "grid",
  gridTemplateColumns: `repeat(${optionCount || 1}, minmax(0, 1fr))`,
  gap: 0,
  width: "100%",
});

export const portraitButtonOption = (
  theme: ThemeV2,
  isSelected: boolean,
  isLast: boolean,
): SystemStyleObject => ({
  minHeight: 44,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  paddingY: 1,
  paddingX: 1.5,
  border: `1px solid ${theme.tokens.color.action.primary}`,
  borderRight: isLast
    ? `1px solid ${theme.tokens.color.action.primary}`
    : "none",
  fontSize: theme.tokens.typography.size.sm,
  fontWeight: theme.tokens.typography.weight.regular,
  color: isSelected
    ? theme.tokens.color.action.primaryText
    : theme.tokens.color.action.primary,
  backgroundColor: isSelected
    ? theme.tokens.color.action.primary
    : theme.tokens.color.surface.card,
  cursor: "pointer",
  userSelect: "none",
  textAlign: "center",
});

export const ratingSliderStyle = (theme: ThemeV2): SystemStyleObject => ({
  "& .MuiSlider-rail": {
    backgroundColor: theme.tokens.color.action.primary,
    opacity: 1,
  },
  "& .MuiSlider-mark.MuiSlider-markActive": {
    backgroundColor: theme.tokens.color.surface.card,
  },
});
